var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 38,
    viewBox: "0 0 75 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.75 12.4685C42.5977 12.4685 41.6667 11.4882 41.6667 10.2747C41.6667 9.0613 42.5977 8.08095 43.75 8.08095H54.1667C55.319 8.08095 56.25 9.0613 56.25 10.2747V21.2437C56.25 22.4571 55.319 23.4374 54.1667 23.4374C53.0143 23.4374 52.0833 22.4571 52.0833 21.2437V15.5741L41.0547 27.1806C40.2409 28.0375 38.9258 28.0375 38.112 27.1806L31.1914 19.9617L22.3066 29.3744C21.4928 30.2313 20.1738 30.2313 19.3602 29.3744C18.5466 28.5174 18.5466 27.1326 19.3602 26.2757L29.7786 15.3067C30.5924 14.4498 31.9076 14.4498 32.7214 15.3067L39.5833 22.5257L49.1341 12.4068L43.75 12.4685Z",
    fill: "#28C195"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.5,
    height: 35.1005,
    fill: "white",
    transform: "translate(18.75 1.49959)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.bdae6c0d842f1c183e2d6d9a19a08723.svg";
export { ForwardRef as ReactComponent };